export default "__VITE_ASSET__DaNbz5fp__"